/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CategoriesRequestDto } from '../models/CategoriesRequestDto';
import type { CategoryDto } from '../models/CategoryDto';
import type { ProductDto } from '../models/ProductDto';
import type { ProductRequestDto } from '../models/ProductRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CatalogService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static catalogControllerSynchronizeCatalog(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/catalog/synchronizeCatalog',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static catalogControllerSynchronizeProducts(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/catalog/synchronizeProducts',
        });
    }

    /**
     * @param requestBody
     * @returns CategoryDto Categories
     * @throws ApiError
     */
    public static catalogControllerCategories(
        requestBody: CategoriesRequestDto,
    ): CancelablePromise<Array<CategoryDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/catalog/categories',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns ProductRequestDto Product Search
     * @throws ApiError
     */
    public static catalogControllerProducts(
        requestBody: ProductRequestDto,
    ): CancelablePromise<ProductRequestDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/catalog/products',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param categoryId
     * @returns ProductRequestDto Products By Category
     * @throws ApiError
     */
    public static catalogControllerProductsByCategory(
        categoryId: string,
    ): CancelablePromise<ProductRequestDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/catalog/productsByCategory{categoryId}',
            path: {
                'categoryId': categoryId,
            },
        });
    }

    /**
     * @returns ProductDto Product Details
     * @throws ApiError
     */
    public static catalogControllerProductDetails(): CancelablePromise<ProductDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/catalog/product-details',
        });
    }

    /**
     * @param id
     * @returns ProductDto Product Details
     * @throws ApiError
     */
    public static catalogControllerGetProductByProductId(
        id: string,
    ): CancelablePromise<ProductDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/catalog/getProductById/{id}',
            path: {
                'id': id,
            },
        });
    }

}
